import axios, { AxiosRequestConfig } from "axios";
import { axiosInterceptor } from "../../utils/axiosInterceptor";
import { validateOktaSession } from "../../utils/validateOktaSession";
let qs = require("qs");

let interceptorInitialized = false;
export function initAxiosInterceptorOnce() {
  if (interceptorInitialized) return;
  interceptorInitialized = true;
  axiosInterceptor();
}

initAxiosInterceptorOnce();

/**
 * API call to fetch access token
 */
export function fetchAccessToken() {
  const data = qs.stringify({
    grant_type: "client_credentials",
  });

  const config: any = {
    method: "post",
    url: `${process.env.REACT_APP_ACCESS_TOKEN_URL}`,
    headers: {
      Authorization: `Basic ${process.env.REACT_APP_OKTA_CLIENT_ACCESS_TOKEN}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data,
  };

  return axios(config)
    .then((response: any) => response.data)
    .catch((error: any) => {
      throw error;
    });
}

function hasRealOkta(): boolean {
  const raw = localStorage.getItem("okta-token-storage");
  return !!raw && raw !== "{}" && raw !== "null" && raw !== "[]";
}

/**
 * API call to fetch id token for logged-in user
 */
export async function fetchIdTokenForLogInUser(props?: any) {
  await validateOktaSession(props);

  let oktaCred: any = {};
  try {
    const raw = localStorage.getItem("okta-token-storage");
    oktaCred = raw && raw !== "{}" ? JSON.parse(raw) : {};
  } catch {
    oktaCred = {};
  }

  const okta_id_token = oktaCred?.idToken?.idToken;
  if (!okta_id_token) {
    throw new Error("Missing okta idToken in okta-token-storage");
  }

  const data = qs.stringify({
    grant_type: "client_credentials",
    assertion: `${okta_id_token}`,
    scope: "openid",
  });

  const config: any = {
    method: "post",
    url: `${process.env.REACT_APP_ACCESS_TOKEN_URL}`,
    headers: {
      Authorization: `Basic ${process.env.REACT_APP_OKTA_CLIENT_ACCESS_TOKEN}`,
    },
    data,
  };

  return axios(config).then((r) => r.data);
}

/**
 * API call to fetch id token from anonymous user
 */
export function createAnonymousSession(createCart: boolean = false) {
  const config: any = {
    method: "get",
    withCredentials: true,
    url: `${process.env.REACT_APP_ANONYMOUS_SESSION_URL}`,
    headers: {
      CREATE_CART_IF_NOT_EXISTS: createCart ? "true" : "false",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  };

  return axios(config).then((res: any) => {
    // If user is actually logged in, don't overwrite commerce_token_storage with anonymous idToken
    if (hasRealOkta()) {
      return res.data;
    }

    let obj: any = {};
    try {
      obj = JSON.parse(localStorage.getItem("commerce_token_storage") || "{}");
    } catch {
      obj = {};
    }

    const time = Math.round(Date.now() / 1000);

    const anonIdToken =
      res?.data?.securityToken?.idToken ??
      res?.data?.securityToken?.id_token ??
      res?.data?.securityToken?.token ??
      res?.data?.idToken ??
      res?.data?.id_token;

    obj.idToken = {
      id_token: anonIdToken,
      partyId: res?.data?.securityAccount?.partyId,
      accountId: res?.data?.securityAccount?.accountId,
      expiresAt:
        res?.data?.securityToken?.expiresIn ??
        res?.data?.securityToken?.expires_in ??
        0,
      expiryTime:
        time +
        Number(
          res?.data?.securityToken?.expiresIn ??
            res?.data?.securityToken?.expires_in ??
            0,
        ),
    };

    localStorage.setItem("commerce_token_storage", JSON.stringify(obj));
    return res.data;
  });
}

/**
 * This call sets commerce tokens in local storage
 */
export async function setAccessToken(props?: any) {
  let obj: any = {};
  try {
    obj = JSON.parse(localStorage.getItem("commerce_token_storage") || "{}");
  } catch {
    obj = {};
  }

  const time = Math.round(Date.now() / 1000);

  const at = await fetchAccessToken();

  obj.accessToken = {
    access_token: at?.access_token,
    expires_in: at?.expires_in,
    expiryTime: time + Number(at?.expires_in || 0),
  };

  localStorage.setItem("commerce_token_storage", JSON.stringify(obj));

  if (hasRealOkta()) {
    let user_info: any = {};
    try {
      user_info = JSON.parse(localStorage.getItem("user-info") || "{}");
    } catch {
      user_info = {};
    }

    const idt = await fetchIdTokenForLogInUser(props);
    obj.idToken = {
      id_token: idt?.id_token,
      partyId: user_info?.partyId,
      accountId: user_info?.accountId,
      expiresAt: idt?.expires_in,
      expiryTime: time + Number(idt?.expires_in || 0),
    };

    localStorage.setItem("commerce_token_storage", JSON.stringify(obj));
  } else {
    await createAnonymousSession(true);
  }
}

// this function returns the current language
export function getLanguage() {
  const currentLanguage =
    sessionStorage.getItem("languageTypeOfApp") || "en-us";
  return currentLanguage.replace("-us", "_US");
}

/**
 * API call to remove hybris session
 */
export async function removeHybrisSession() {
  const config: AxiosRequestConfig = {
    method: "get",
    withCredentials: true,
    url: `${process.env.REACT_APP_COMMERCE_LOGOUT_URL}`,
    headers: {},
  };

  const res = await axios(config);
  return res.data;
}